import clsx from "clsx";
import { PX_PER_MINUTE } from "../../utils/timeGrid";

interface BlockDragGhostProps {
  label: string;
  spanMinutes: number;
  kind: "scheduled-poi" | "note";
}

/**
 * Drag overlay for grid block drags — block-shaped (height matches the
 * block's span) so the drag reads as moving the block, not a card.
 */
export function BlockDragGhost({
  label,
  spanMinutes,
  kind,
}: BlockDragGhostProps) {
  const height = Math.min(Math.max(spanMinutes * PX_PER_MINUTE, 28), 320);

  return (
    <div
      className={clsx(
        "w-56 cursor-grabbing overflow-hidden rounded-lg border-l-4 px-2 py-1 opacity-90 shadow-xl",
        kind === "note"
          ? "border-l-sky-500 bg-slate-800 text-slate-100"
          : "border border-blue-200 border-l-info bg-surface text-primary",
      )}
      style={{ height }}
    >
      <span className="text-xs font-bold leading-tight">{label}</span>
    </div>
  );
}
